import { render, staticRenderFns } from "./CalendarFontField.vue?vue&type=template&id=09f9ce2e"
import script from "./CalendarFontField.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarFontField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports